import { useQuery } from '@tanstack/react-query';

import { type ContactListParams, contactKeys, contactsApi } from './api';

/**
 * The suggestions of a recipient field, for what was typed (already debounced by the
 * caller). Nothing is asked while nothing is typed: the field is for writing, and three of
 * them on one sheet would ask three times on every focus. What was asked a moment ago
 * stays on screen while the next answer comes, so the list does not blink at every key.
 */
export function useContactSuggestions(q: string, mailbox: string) {
  const typed = q.trim();
  return useQuery({
    queryKey: contactKeys.suggest(typed, mailbox),
    queryFn: () => contactsApi.suggest(typed, mailbox),
    enabled: typed.length > 0,
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });
}

/** One page of the address book, the previous one on screen while the next loads. */
export function useContactList(params: ContactListParams) {
  return useQuery({
    queryKey: contactKeys.list(params),
    queryFn: () => contactsApi.list(params),
    placeholderData: (previous) => previous,
  });
}

export function useContactGroups() {
  return useQuery({ queryKey: contactKeys.groups, queryFn: contactsApi.groups });
}
